import { FC } from 'react';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: '14px',
    padding: '4px 8px',
    borderRadius: '20px',
    fontWeight: 500,
    display: 'inline-block',
    minWidth: 60,
    textAlign: 'center',
    borderStyle: 'solid',
    borderWidth: '1px',
  },
  active: {
    backgroundColor: '#E6F6EE',
    color: '#289A29',
    borderColor: '#289A29',
  },
  future: {
    backgroundColor: '#E6F1F8',
    color: '#4297CD',
    borderColor: '#4297CD',
  },
  expired: {
    backgroundColor: '#FDF2F2',
    color: '#E74D4D',
    borderColor: '#E74D4D',
  },
}));

const STATUS_LABELS: Record<string, string> = {
  Active: 'Active',
  Future: 'Future',
  Expired: 'Expired',
};

type PromoStatusBadgeProps = {
  status: 'Active' | 'Future' | 'Expired';
};

const PromoStatusBadge: FC<PromoStatusBadgeProps> = ({ status }: PromoStatusBadgeProps) => {
  const classes = useStyles();

  return (
    <Box className={`${classes.root} ${classes[status.toLowerCase()]}`}>
      {STATUS_LABELS[status]}
    </Box>
  );
};

export default PromoStatusBadge;
